<template>
  <div :class="{fixed:isFix}">
    <!-- <div class="wechatShare" @click="showImg('none', '')">
      <img src="./img/WechatShare.png" @click="showImg('none', '')" />
      <p>戳这里赶快分享给好友吧！</p>
      <p>朋友圈配文已复制，</p>
      <van-popup class="popup" v-model="show" :overlay='false'  round position="bottom" :style='{height:"220px"}'>
        <div class="article-title">朋友圈配文</div>
        <div class="article-content">
          萧建华先生，凤凰树文学奖、凤凰剧展最佳演员奖、第11届全球热爱生命奖获得者。当萧先生在遭遇重疾后，在一次公开演讲说到：当初我拒绝保险 现在被保险拒绝。拒绝保险是因为我无知，但如果因为害怕被拒绝，而放弃了教育我的机会，这就是保险业务员的无能。
          希望籍由我切身之痛，能唤醒每一位保险天使勇于承担对生命、家庭乃至社会的使命感，不要推卸责任，要克服困难。就像坚持热爱生命一样，只要还有一口气，绝不轻言放弃。老百姓之所以拒绝，是观念不强，理解不深。不懂保险。保险是责任，是一种爱的表达，不怕拒绝的保险代理人才能成为真正爱的天使，让保障能进入更多的家庭中。
        </div>
      </van-popup>
      <div class="matchTitle">
        <p>朋友圈配文</p>
        <div class="content">
          {{ artcsummary ? artcsummary : "暂无配文" }}
        </div>
        <p>以上文字已复制，请在分享时使用</p>
      </div>
    </div> -->
    <van-overlay :show="showShareTip" @click="showShareTip = false;isFix = false;" :lock-scroll='lock_scroll'>
      <img
        style="width:100px;height:100px;position:absolute;right:30px;top:4px"
        src="./img/WechatShare-new.png"
        alt=""
      />
      <P
        style="text-align:center;position:absolute;top:120px;right:20%;color:#fff;font-size:16px;"
        >戳这里赶快分享给好友吧！<br />朋友圈配文已复制，</P
      >
      <div class="matchTitle">
        <p>朋友圈配文</p>
        <div class="content">
          {{ artcsummary ? artcsummary : "暂无配文" }}
        </div>
        <p>以上文字已复制，请在分享时使用</p>
      </div>
    </van-overlay>

    <van-overlay :show="showAllTip" @click="showAllTip = false;isFix = false;" :lock-scroll='lock_scroll'>
      <div class="matchTitle">
        <p>视频详情</p>
        <div class="content">
          {{ artcsummary ? artcsummary : "暂无配文" }}
        </div>
      </div>
    </van-overlay>

    <div class="top-search">
      <van-icon
        @click="$router.go(-1)"
        name="arrow-left"
        color="#FFFFFF"
        size="24px"
      />
      <van-icon @click="navigate" name="search" color="#FFFFFF" size="24px" />
    </div>
    <van-swipe
      ref="swiper"
      style="height: 100vh;"
      vertical
      :show-indicators="false"
      :loop="false"
      :stop-propagation="false"
      @change="change"
    >
      <van-swipe-item
        v-for="(item, index) in list"
        :key="index"
        style="background-color: black"
      >
        <div
          style="position: relative"
          v-if="Math.abs(currentIndex - index) <= 1"
        >
          <video
            class="v-item"
            :class="'video' + index"
            :ref="'video' + index"
            webkit-playsinline="true"
            controlslist="nodownload"
            playsinline="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            :poster="item.faceImgUrl || item.imgUrl1"
            controls
          >
            <source :src="item.vodUrl" type="video/webm" @click="clickVideo" />
            <source :src="item.vodUrl" type="video/mp4" @click="clickVideo"/>
          </video>
          <!-- :class="{v_text_index: isIndex}" -->
          <div class="v-text" @click="playVideo(index)" >
            <div class="v-t-left">
              <div class="v-t-top">
                <div class="left">
                  <img :src="jobPic" class="v-t-l-header" />
                  <div class="namePhone">
                    <p>{{ name }}</p>
                    <div class="phone">
                      <p>{{ tel }}</p>
                      <a :href="'tel:' + tel">
                        <img src="./img/call.png" alt="" />
                      </a>
                    </div>
                  </div>
                </div>
                <div class='right-content'>
                  <div class="change-to-mine" @click.stop="checkUser" v-if="changeMe">换成我的</div>
                  <div class="right" @click.stop="goToMyCard">查看详情</div>
                </div>

              </div>
              <div class="v-t-middle">
                <div class="v-t-m-content">
                  <p>
                    {{ item.title }}分享配文：<br />
                    <p class="noBr" v-html="formate(item.artcSummary)"></p>
                  </p>
                </div>
                <div class="v-t-m-more" @click.stop="showAll(index, item.artcSummary)">
                  查看详情
                  <van-icon
                    name="arrow-down"
                    color="#FFFFFF"
                    class="arrow-down"
                    :class="{ 'arrow-down-active': false }"
                  />
                </div>
              </div>
              <div class="v-t-bottom">
                <!-- <span>{{ item.time }}</span> -->
                <div class="left">
                  <span>阅读{{ item.viewCount }}次</span>
                  <span>转发{{ item.fwdCount }}次</span>
                </div>
                <div class="right">
                  <img @click.stop="showSheet = true" src="./img/comp.png" />
                  <span>举报</span>
                </div>
              </div>
            </div>
            <div class="v-t-right">
              <div>
                <img
                  @click.stop="showShare(index, item.artcSummary)"
                  src="./img/share.png"
                />
                <span>分享</span>
              </div>
            </div>
            <!-- <van-icon
              name="play-circle-o"
              size="60"
              color="#ffffff"
              v-show="playStatus"
              class="play-circle"
            /> -->
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>
    <van-action-sheet
      v-model="showSheet"
      :round="false"
      :actions="actions"
      @select="complaint"
      cancel-text="取消"
      description="问题内容"
      close-on-click-action
    />
  </div>
</template>

<script>
import URL from "@/api/api";
import {Toast} from "vant";
import { queryVideoList, ws } from "./invoker/api";
import wx from "weixin-js-sdk";
export default {
  components: {
  },
  data() {
    return {
      baseUrl: "",
      ahtor_openId: "",
      list: [],
      playStatus: true,
      nextPage: 2,
      teb_type: "",
      currentIndex: 0,
      hasNextPage: true,
      artc_id: "",
      name: "",
      tel: "",
      jobPic: "",
      shareLink: "",
      url: "",
      copyText: "",
      friendTitle: "",
      showSheet: false,
      isAdmin: false,
      firstTransferPerson: "",
      lastTransferPerson: "",
      actions: [
        { id: 0, name: "举报非此品牌内容", className: "one" },
        { id: 1, name: "举报文章内容质量差", className: "one" },
        { id: 2, name: "涉及欺诈、色情、版权问题", className: "one" }
      ],
      show: false,
      isReg: false,
      showCard: false,
      // cardInfo: {},
      changeMe: true,
      unionid: 'oP22H5hNvYVvb92xlAnM6e4EcoIs',
      showShareTip: false,
      showAllTip: false,
      artcsummary: '',
      lock_scroll: false,
      isFix:false,
      staffId: '',
    };
  },
  computed: {
    transid: () => {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === "function") {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function(c) {
          var r = (d + Math.random() * 16) % 16 | 0;
          d = Math.floor(d / 16);
          return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
      return uuid;
    }
  },
  async mounted() {
    if (location.hostname === "zf.dtfcloud.com") {
      this.baseUrl = "https://zf.dtfcloud.com/";
    } else {
      this.baseUrl = "https://jzt.dtfcloud.com/";
    }
    this.unionid = sessionStorage.getItem("unionid");
    this.getStaffId()
    if (!this.getUrlParams("firstTransferPerson")) {
      this.changeMe = false;
    } else {
      if (this.unionid == this.getUrlParams("firstTransferPerson")) {
        this.changeMe = false;
      }
    }
    this.$fetchPost(URL.checkAuthority.url,{
      unionid: this.getUrlParams("firstTransferPerson")
    }).then(res => {
      if (res.data) {
        if (res.data.data) {
          this.isAdmin = true;
        }
        // this.articleId =this.$route.query.articleId ||sessionStorage.getItem("articleId");
        this.firstTransferPerson = this.getUrlParams("firstTransferPerson")
          ? this.isAdmin
            ? sessionStorage.getItem("unionid")
            : this.getUrlParams("firstTransferPerson")
          : sessionStorage.getItem("unionid");
        this.lastTransferPerson = this.getUrlParams("lastTransferPerson");
        this.ahtor_openId = this.getUrlParams("first_openid")
          ? this.isAdmin
            ? sessionStorage.getItem("openId")
            : this.getUrlParams("first_openid")
          : sessionStorage.getItem("openId");
        // this.ahtor_openId=this.getUrlParams('first_openId')?this.getUrlParams('first_openId'):sessionStorage.getItem('openId');
      }
    });
    let that = this;
    const { appId, noncestr: nonceStr, signature, timestamp } = await ws({
      url: location.href.split("#")[0]
    });
    wx.config({
      debug: false,
      appId,
      timestamp,
      nonceStr,
      signature,
      jsApiList: [
        "updateAppMessageShareData",
        "updateTimelineShareData",
        "onMenuShareAppMessage",
        "onMenuShareTimeline"
      ],
      openTagList: ["wx-open-launch-weapp"]
    });
    wx.error(function(res) {
    });
    this.$fetchGet(URL.getCardByUnionid.url, {
      unionid: sessionStorage.getItem("unionid")
    }).then(res => {
      if (res.data.data != null) {
        this.name = res.data.data.name;
        this.tel = res.data.data.tel;
        this.jobPic = res.data.data.headerImg;
      } else {
        this.name = "i致富";
        this.jobPic = require("./img/logo.png");
      }
    });
    Toast.loading({ message: "加载中...", forbidClick: true });
    const {
      now_page = 1,
      teb_type = "",
      currentIndex = 0,
      articleId: artc_id = ""
    } = this.$route.query;
    const data = { now_page, row_num: 5, teb_type, artc_id };
    const { list, nextPage, hasNextPage } = await queryVideoList(data);
    this.list = list;

    let title = this.list[0].artcSummary.replace(/<br\/>/g, "");
    this.friendTitle = title;

    this.teb_type = teb_type;
    this.nextPage = nextPage;
    this.hasNextPage = hasNextPage;
    this.artc_id = list[0].artcId
      ? list[0].artcId
      : this.getUrlParams("articleId");
    this.$nextTick(() => {
      // let firstTransferPerson=sessionStorage.getItem("firstTransferPerson")?sessionStorage.getItem("firstTransferPerson"):sessionStorage.getItem("unionid");
      this.url =
        location.origin +
        "/article/index.html#/video?type=VOD&firstTransferPerson=" +
        this.firstTransferPerson +
        "&articleId=" +
        this.list[this.currentIndex].artcId +
        "&lastTransferPerson=" +
        sessionStorage.getItem("unionid");
      this.shareLink =
        location.origin +
        "/article/static/html/redirect.html?app3Redirect=" +
        encodeURIComponent(this.url);
      this.$refs.swiper.swipeTo(currentIndex, { immediate: true });
      const { artcSummary: desc, faceImgUrl, imgUrl1 } = this.list[
        currentIndex
      ];
      if (sessionStorage.getItem("firstTransferPerson")) {
        var activeData = {
            transId: that.transid,
            timeFlag: that.getTimeStamp(2),
            actionType: "visit",
            action: "ACT6",
            userId: sessionStorage.getItem("unionid")? sessionStorage.getItem("unionid") : sessionStorage.getItem("openId"),
            unionid: sessionStorage.getItem("unionid"),
            funcId: that.getUrlParams("articleId"),
            url: window.location.href,
            fromUrl: document.referrer,
            productId: that.getUrlParams("type"),
            buttonId: sessionStorage.getItem("firstTransferPerson"),
            accessType: "V1",
            source:'wx',
            nikename: sessionStorage.getItem("nickname"),
            headImgUrl: sessionStorage.getItem("headImgUrl"),
            customerId:sessionStorage.getItem("unionid"),
            funcName: this.list[this.currentIndex].vtitle ? this.list[this.currentIndex].vtitle : "视频分享"

        };
        that.submitUserActive(activeData);
        that.submitVisitedTimes();
    }



      wx.ready(() => {
        //需在用户可能点击分享按钮前就先调用
        wx.onMenuShareAppMessage({
          title: this.list[this.currentIndex].vtitle
            ? this.list[this.currentIndex].vtitle
            : "视频分享", // 分享标题
          desc: this.list[this.currentIndex].artcSummary, // 分享描述
          link: this.shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: faceImgUrl || imgUrl1,
          success: function() {
            // alert(_ok)
            // 用户确认分享后执行的回调函数
            that.$fetchPost(URL.articleShareSuccess.url,{
                activitieId: that.artc_id,
                customerName: that.name,
                customerPhoneNumber: that.tel,
                firstTransferPerson: sessionStorage.getItem( "firstTransferPerson") ? sessionStorage.getItem("firstTransferPerson") : sessionStorage.getItem("unionid"),
                lastTransferPerson: sessionStorage.getItem("unionid"),
                activityType: "VOD",
                agtid: sessionStorage.getItem("unionid"),
                unionid: sessionStorage.getItem("unionid"),
                nikename: sessionStorage.getItem("nickname"),
                headImgUrl: sessionStorage.getItem("headImgUrl"),

                temp: "0",
                wechatNumber: sessionStorage.getItem("firstTransferPerson") != sessionStorage.getItem("unionid") && sessionStorage.getItem("firstTransferPerson") ? sessionStorage.getItem("unionid") : "",
                source:'wx',
                customerId:sessionStorage.getItem("unionid"),
                funcName:this.list[this.currentIndex].vtitle ? this.list[this.currentIndex].vtitle : "视频分享"

            });
          }
        });
        wx.onMenuShareTimeline({
          title: this.list[this.currentIndex].vtitle
            ? this.list[this.currentIndex].vtitle
            : "视频分享", // 分享标题
          desc: this.list[this.currentIndex].artcSummary, // 分享描述
          link: this.shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: faceImgUrl || imgUrl1,
          success: function() {
            // alert(_ok)
            // 用户确认分享后执行的回调函数
            that.$fetchPost(URL.articleShareSuccess.url,{
                activitieId: that.artc_id,
                customerName: that.name,
                customerPhoneNumber: that.tel,
                firstTransferPerson: sessionStorage.getItem( "firstTransferPerson") ? sessionStorage.getItem("firstTransferPerson") : sessionStorage.getItem("unionid"),
                lastTransferPerson: sessionStorage.getItem("unionid"),
                activityType: "VOD",
                agtid: sessionStorage.getItem("unionid"),
                unionid: sessionStorage.getItem("unionid"),
                nikename: sessionStorage.getItem("nickname"),
                headImgUrl: sessionStorage.getItem("headImgUrl"),
                temp: "0",
                wechatNumber: sessionStorage.getItem("firstTransferPerson") != sessionStorage.getItem("unionid") && sessionStorage.getItem("firstTransferPerson") ? sessionStorage.getItem("unionid") : "",
                source:'wx',
                customerId:sessionStorage.getItem("unionid"),
                funcName:this.list[this.currentIndex].vtitle ? this.list[this.currentIndex].vtitle : "视频分享"

              // wechatNumber:sessionStorage.getItem("firstTransferPerson")!=sessionStorage.getItem("unionid")&&sessionStorage.getItem("firstTransferPerson")?sessionStorage.getItem("unionid"):'',
            });
          }
        });
      });
    });
    Toast.clear();
    // this.playVideo(0);
  },
  methods: {
    complaint(e) {
      (e.name);
      this.$fetchPost(URL.insertComplaints.url,{
        artcid: this.list[this.currentIndex].artcId,
        artctype: this.list[this.currentIndex].contentType,
        userid: this.ahtor_openId,
        complain: e.name
      }).then(res => {
      });
      Toast("举报成功");
    },
    goToMyCard() {
      if (location.hostname === "zf.dtfcloud.com") {
        window.location.href = this.baseUrl + "loan-pro/#/cDetails?flg=1&isInfo=1&id=" + this.staffId;
      } else {
        window.location.href = this.baseUrl + "loan-test/#/cDetails?flg=1&isInfo=1&id=" + this.staffId;
      }
      // window.location.href =
      //   this.baseUrl +
      //   "centre/index.html#/myCardView?first_openId=" +
      //   this.ahtor_openId +
      //   "&firstTransferPerson=" +
      //   sessionStorage.getItem("unionid");
    },
    getStaffId() {
      let that = this;
      let unionId = sessionStorage.getItem("unionid");
      that.$fetchGet(URL.getCardByUnionid.url, {
          unionid: unionId ? unionId : '',
        })
        .then((res) => {
          if (res.data.code == "20000") {
            if (res.data.data != null) {
              this.staffId = res.data.data.id;
            }
          }
        });
    },
    formate(text) {
      // text.replaceAll("(.)(\1*)","$1");
      // return text.replace(/(.).*\1/g,"$1")
      /*eslint-disable*/
      return text.replace(/[<br\/>]+/g, "<br/>");
    },
    navigate() {
      this.$router.push({
        path: "/search",
        query: {
          openId: sessionStorage.getItem("openId"),
          teb_type: this.teb_type
        }
      });
    },
    getUrlParams: function(paramsName) {
      const url = window.location.href; //当前页面的地址
      const reg = /([^?&=]+)=([^?&=]+)/g,
        obj = {};
      url.replace(reg, function() {
        obj[arguments[1]] = arguments[2];
      });
      for (let keyName in obj) {
        if (keyName === paramsName) {
          return obj[keyName];
        }
      }
    },
    playVideo(index) {
      const video = document.querySelector(".video" + index);
      console.dir(video);
      this.playStatus ? video.play() : video.pause();
      this.playStatus = !this.playStatus;
      // this.playStatus ? this.isIndex=false : this.isIndex=true;
      video.addEventListener(
        "ended",
        () => {
          this.playStatus = true;
        },
        { once: true }
      );
    },
    clickVideo() {
    },
    showShare(vIndex, copyText) {
      this.showShareTip = true;
      this.isFix = true;
      // const wechatShare = document.querySelector(".wechatShare");
      /*eslint-disable*/
      copyText = copyText.replace(/[<br\/>]+/g, "\n");

      this.$copyText(copyText)
        .then(res => {
          this.artcsummary = copyText;
          Toast("朋友圈配文已复制");
        })
        .catch(err => {});
      // this.copyText();
    },
    showAll(vIndex, copyText) {
      this.showAllTip = true;
      this.isFix = true;
      // const wechatShare = document.querySelector(".wechatShare");
      /*eslint-disable*/
      copyText = copyText.replace(/[<br\/>]+/g, "\n");

      this.$copyText(copyText)
        .then(res => {
          this.artcsummary = copyText;
        })
        .catch(err => {});
      // this.copyText();
    },
    checkAuth() {
      var that = this;
      that
        // .$post("authentication", {
        //   openid: that.openId,
        //   unionid: sessionStorage.getItem("unionid"),
        //   id: "3"
        // })
        // .then(res => {
        //   if (res.data == 0) {
            that.firstTransferPerson = sessionStorage.getItem("unionid");
            that.getCard(); //拥有权限
            that.changeMe = false;
            let url =
              that.baseUrl +
              "article/index.html#/articleDetails?articleId=" +
              that.articleId +
              "&firstTransferPerson=" +
              that.firstTransferPerson +
              "&lastTransferPerson=" +
              sessionStorage.getItem("unionid");
            that.shareLink =
              that.baseUrl +
              "article/static/html/redirect.html?app3Redirect=" +
              encodeURIComponent(url);
            that.share(
              that.title,
              that.artcsummary,
              that.shareLink,
              that.shareImg
            );
          // } else if (res.data == 1) {
          //   let cardUrl = "";
          //   Toast("查询到您未设置名片，稍后将跳转到名片设置页");
          //   if (location.hostname === "dtfcloud.com") {
          //     cardUrl =
          //       "https://dtfcloud.com/centre/index.html#/myCardEdit?openId=" +
          //       sessionStorage.getItem("openId") +
          //       "&unionid=" +
          //       sessionStorage.getItem("unionid") +
          //       "&isReg=no";
          //   } else {
          //     cardUrl =
          //       "http://jzt.dtfcloud.com/centre/index.html#/myCardEdit?openId=" +
          //       sessionStorage.getItem("openId") +
          //       "&unionid=" +
          //       sessionStorage.getItem("unionid") +
          //       "&isReg=no";
          //   }
          //   setTimeout(function() {
          //     // window.location.href = cardUrl; // that.showCode=true;
          //   }, 1500);
          // }
        // })
        // .catch(err => {
        // });
    },
    //验证是否是注册用户
    checkUser(e) {
      e.stopPropagation();
      this.$fetchGet(URL.checkUser.url,{
        openId: sessionStorage.getItem("openId"),
        nikeName: sessionStorage.getItem("nickname")
        // openId:sessionStorage.getItem('openId'),
        // nikeName:'HLH'
      }).then(res => {
        if (res.ret == "00000") {
          //已注册
          this.isReg = true;
          this.checkAuth();
        }
        if (res.ret == "200009") {
          //用户未注册
          let registerUrl = "";
          this.isReg = false;
          Toast("你还未注册i致富，即将跳转到注册页面");

          if (location.hostname === "ufc.dtfcloud.com") {
            registerUrl =
              "https://ufc.dtfcloud.com/#/register?openId=" +
              sessionStorage.getItem("openId") +
              "&unionid=" +
              sessionStorage.getItem("unionid") +
              "&isReg=no";
          } else {
            registerUrl =
              "https://jzt.dtfcloud.com/#/register?openId=" +
              sessionStorage.getItem("openId") +
              "&unionid=" +
              sessionStorage.getItem("unionid") +
              "&isReg=no";
          }
          setTimeout(function() {
            // window.location.href = registerUrl;
          }, 1500);
        }
        if (res.ret == "200008") {
          // alert("您还未注册");
          this.isReg = false;
        }
      });
    },
    getCard(id) {
      let that = this;
      that.$fetchGet(URL.getCardByUnionid.url, {
          unionid: this.firstTransferPerson ? this.firstTransferPerson : id
        })
        .then(res => {
          if (res.ret === "00000") {
            if (res.data != null) {
              that.tel = res.data.tel;
              that.name = res.data.name;
              that.showCard = true;
            } else {
              that.cardInfo = {
                name: "i致富",
                tel: "",
                headerImg: require("./img/bin.png")
              };
            }
          }
        });
    },
    async change(index) {
      let that = this;
      this.currentIndex = index;
      const length = this.list.length;
      const { nextPage: now_page, teb_type, artc_id } = this;
      if (index === length - 1 && this.hasNextPage) {
        const data = { now_page, row_num: 5, teb_type, artc_id };
        const { list, nextPage, hasNextPage } = await queryVideoList(data);
        this.list = [...this.list, ...list];

        let title = this.list[this.currentIndex].artcSummary.replace(
          /<br\/>/g,
          ""
        );
        this.friendTitle = title;

        this.hasNextPage = hasNextPage;
        this.$nextTick(() => {
          this.$refs.swiper.swipeTo(this.currentIndex, { immediate: true });
          const { artcSummary: desc, faceImgUrl, imgUrl1 } = this.list[
            this.currentIndex
          ];
          // let firstTransferPerson=sessionStorage.getItem("firstTransferPerson")?sessionStorage.getItem("firstTransferPerson"):sessionStorage.getItem("unionid");
          this.url =
            location.origin +
            "/article/index.html#/video?type=VOD&firstTransferPerson=" +
            this.firstTransferPerson +
            "&articleId=" +
            this.list[this.currentIndex].artcId +
            "&lastTransferPerson=" +
            sessionStorage.getItem("unionid");
          this.shareLink =
            location.origin +
            "/article/static/html/redirect.html?app3Redirect=" +
            encodeURIComponent(this.url);
          wx.onMenuShareAppMessage({
            title: this.list[this.currentIndex].vtitle
              ? this.list[this.currentIndex].vtitle
              : "视频分享", // 分享标题
            desc: this.list[this.currentIndex].artcSummary, // 分享描述
            link: this.shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: this.list[this.currentIndex].faceImgUrl,
            success: function() {
              // alert(_ok)
              // 用户确认分享后执行的回调函数
              that.$fetchPost(URL.articleShareSuccess.url,{
                activitieId: that.artc_id,
                customerName: that.name,
                customerPhoneNumber: that.tel,
                firstTransferPerson: sessionStorage.getItem( "firstTransferPerson") ? sessionStorage.getItem("firstTransferPerson") : sessionStorage.getItem("unionid"),
                lastTransferPerson: sessionStorage.getItem("unionid"),
                activityType: "VOD",
                agtid: sessionStorage.getItem("unionid"),
                unionid: sessionStorage.getItem("unionid"),
                nikename: sessionStorage.getItem("nickname"),
                temp: "0",
                wechatNumber: sessionStorage.getItem("firstTransferPerson") != sessionStorage.getItem("unionid") && sessionStorage.getItem("firstTransferPerson") ? sessionStorage.getItem("unionid") : "",
                source:'wx',
                customerId:sessionStorage.getItem("unionid"),
                funcName:this.list[this.currentIndex].vtitle ? this.list[this.currentIndex].vtitle : "视频分享"
              });
            }
          });
          wx.onMenuShareTimeline({
            title: this.list[this.currentIndex].vtitle
              ? this.list[this.currentIndex].vtitle
              : "视频分享", // 分享标题
            desc: this.list[this.currentIndex].artcSummary, // 分享描述
            link: this.shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: faceImgUrl || imgUrl1,
            success: function() {
              // alert(_ok)
              // 用户确认分享后执行的回调函数
              that.$fetchPost(URL.articleShareSuccess.url,{
                activitieId: that.artc_id,
                customerName: that.name,
                customerPhoneNumber: that.tel,
                firstTransferPerson: sessionStorage.getItem( "firstTransferPerson") ? sessionStorage.getItem("firstTransferPerson") : sessionStorage.getItem("unionid"),
                lastTransferPerson: sessionStorage.getItem("unionid"),
                activityType: "VOD",
                agtid: sessionStorage.getItem("unionid"),
                unionid: sessionStorage.getItem("unionid"),
                nikename: sessionStorage.getItem("nickname"),
                temp: "0",
                wechatNumber: sessionStorage.getItem("firstTransferPerson") != sessionStorage.getItem("unionid") && sessionStorage.getItem("firstTransferPerson") ? sessionStorage.getItem("unionid") : "",
                source:'wx',
                customerId:sessionStorage.getItem("unionid"),
                funcName:this.list[this.currentIndex].vtitle ? this.list[this.currentIndex].vtitle : "视频分享"
              });
            }
          });
        });
        this.nextPage = nextPage;
      } else {
        this.$refs.swiper.swipeTo(this.currentIndex, { immediate: true });
        const { artcSummary: desc, faceImgUrl, imgUrl1 } = this.list[
          this.currentIndex
        ];
        // let firstTransferPerson=sessionStorage.getItem("firstTransferPerson")?sessionStorage.getItem("firstTransferPerson"):sessionStorage.getItem("unionid");
        this.url =
          location.origin +
          "/article/index.html#/video?type=VOD&firstTransferPerson=" +
          this.firstTransferPerson +
          "&articleId=" +
          this.list[this.currentIndex].artcId +
          "&lastTransferPerson=" +
          sessionStorage.getItem("unionid");
        this.shareLink =
          location.origin +
          "/article/static/html/redirect.html?app3Redirect=" +
          encodeURIComponent(this.url);
        wx.onMenuShareAppMessage({
          title: this.list[this.currentIndex].vtitle
            ? this.list[this.currentIndex].vtitle
            : "视频分享", // 分享标题
          desc: this.list[this.currentIndex].artcSummary, // 分享描述
          link: this.shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.list[this.currentIndex].faceImgUrl,
          success: function() {
            // alert(_ok)
            // 用户确认分享后执行的回调函数
            that.$fetchPost(URL.articleShareSuccess.url,{
                activitieId: that.artc_id,
                customerName: that.name,
                customerPhoneNumber: that.tel,
                firstTransferPerson: sessionStorage.getItem( "firstTransferPerson") ? sessionStorage.getItem("firstTransferPerson") : sessionStorage.getItem("unionid"),
                lastTransferPerson: sessionStorage.getItem("unionid"),
                activityType: "VOD",
                agtid: sessionStorage.getItem("unionid"),
                unionid: sessionStorage.getItem("unionid"),
                nikename: sessionStorage.getItem("nickname"),
                temp: "0",
                wechatNumber: sessionStorage.getItem("firstTransferPerson") != sessionStorage.getItem("unionid") && sessionStorage.getItem("firstTransferPerson") ? sessionStorage.getItem("unionid") : "",
                source:'wx',
                customerId:sessionStorage.getItem("unionid"),
                funcName:this.list[this.currentIndex].vtitle ? this.list[this.currentIndex].vtitle : "视频分享"

            });
          }
        });
        wx.onMenuShareTimeline({
          title: this.list[this.currentIndex].vtitle
            ? this.list[this.currentIndex].vtitle
            : "视频分享", // 分享标题
          desc: this.list[this.currentIndex].artcSummary, // 分享描述
          link: this.shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: faceImgUrl || imgUrl1,
          success: function() {
            // alert(_ok)
            // 用户确认分享后执行的回调函数
            that.$fetchPost(URL.articleShareSuccess.url,{
                activitieId: that.artc_id,
                customerName: that.name,
                customerPhoneNumber: that.tel,
                firstTransferPerson: sessionStorage.getItem( "firstTransferPerson") ? sessionStorage.getItem("firstTransferPerson") : sessionStorage.getItem("unionid"),
                lastTransferPerson: sessionStorage.getItem("unionid"),
                activityType: "VOD",
                agtid: sessionStorage.getItem("unionid"),
                unionid: sessionStorage.getItem("unionid"),
                nikename: sessionStorage.getItem("nickname"),
                temp: "0",
                wechatNumber: sessionStorage.getItem("firstTransferPerson") != sessionStorage.getItem("unionid") && sessionStorage.getItem("firstTransferPerson") ? sessionStorage.getItem("unionid") : "",
                source:'wx',
                customerId:sessionStorage.getItem("unionid"),
                funcName:this.list[this.currentIndex].vtitle ? this.list[this.currentIndex].vtitle : "视频分享"

            });
          }
        });
      }
      this.playStatus = false;
      const videoLists = document.querySelectorAll("video");
      videoLists.forEach((item, itemIndex) => {
        if (index === itemIndex) {
          this.playStatus ? item.pause() : item.play();
          item.addEventListener(
            "ended",
            () => {
              this.playStatus = true;
            },
            { once: true }
          );
        } else {
          item.pause();
        }
      });
    },
    showImg(display, copyText) {
      // let title = (this.list[0].artcSummary).replace(/<br\/>/g, "");
      // this.friendTitle = title;

      const wechatShare = document.querySelector(".wechatShare");
      /*eslint-disable*/
      copyText = copyText.replace(/[<br\/>]+/g, "\n");

      this.$copyText(copyText)
        .then(res => {
        })
        .catch(err => {});
      this.show = display === 'block';
      wechatShare.style.display = display;
    },
    getTimeStamp: function(format) {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      //精确到天
      if (format == 1) {
        time = year + "-" + month + "-" + date;
      }
      //精确到分
      else if (format == 2) {
        time =
          year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      }
      return time;
    },
    submitUserActive: function(obj) {
      let that = this;
      that.$fetchPost(URL.userActive.url,JSON.stringify(obj)).then(res=>{
      });
      // alert('提交成功')
    },
    //统计时长
    submitVisitedTimes() {
      let that = this;
      let data = {
        transId: that.transid,
        viewDuration: 5
      };
      that.$fetchPost(URL.subViewduration.url,data).then(res=>{
        if (res.ret == "00000") {
          setTimeout(function() {
            that.submitVisitedTimes();
          }, 5000);
        }
      });
    }
  }
};
</script>

<style scoped>
.van-action-sheet__gap {
  height: 2px;
}
.van-action-sheet__description {
  color: #383838;
  font-size: 16px;
  font-weight: bold;
}
.one {
  color: #383838;
  font-size: 14px;
}
.noBr {
  white-space: pre-wrap;
}

.v-item {
  width: 100vw;
  height: 95vh;
  object-fit: contain;
  object-position: center center;
}
.v-text {
  position: absolute;
  width: 100vw;
  height: 90vh;
  top: 0;
  left: 0;
  /* bottom: 100px; */
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}
.v-t-left {
  width: 100%;
  padding: 0 15px;
  position: absolute;
  display: flex;
  flex-direction: column;
  bottom: 10px;
  z-index: 100;
  /* left: 15px; */
}
.v-t-top {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  margin-bottom: 16px;
}
.v-t-top .left {
  display: flex;
  font-size: 15px;
  align-items: center;
}
.v-t-top .left img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 6px;
}
.v-t-top .left .namePhone .phone {
  font-size: 13px;
  margin-top: 2px;
  display: flex;
  align-items: center;
}
.v-t-top .left .namePhone .phone img {
  width: 14px;
  height: 14px;
  margin-left: 4px;
}
.v-t-top .right-content {
  display: flex;
  font-size: 15px;
  align-items: center;
}
.v-t-top .change-to-mine {
  width: 72px;
  height: 30px;
  border-radius: 17px;
  border: 1px solid #FF6927;
  font-size: 13px;
  font-weight: 400;
  color: #FF6927;
  line-height: 30px;
  text-align: center;
  margin-right: 12px;
}
.v-t-top .right {
  width: 72px;
  height: 30px;
  background: linear-gradient(to right, #ff983f, #ff4c32);
  text-align: center;
  line-height: 30px;
  border-radius: 15px;
  font-size: 13px;
}

.v-t-m-content {
  color: #ffffff;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
/* .active {
  -webkit-line-clamp: 13;
} */
.v-t-l-header {
  box-sizing: border-box;
  position: relative;
}
.v-t-l-header img:nth-child(1) {
  width: 50px !important;
  height: 50px !important;
  border-radius: 50%;
}
.v-t-l-header img:nth-child(2) {
  width: 24px;
  height: 18px;
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translate(-50%);
}
.v-t-right {
  position: absolute;
  right: 15px;
  bottom: 210px;
  display: flex;
  flex-direction: column;
  z-index: 100;
  align-items: center;
}
.launch-btn {
  width: 100%;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
}
.v-t-right img {
  width: 38px;
  height: 38px;
  margin-top: 20px;
}
.v-t-right > div {
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #999999;
}
.v-t-right > div:first-child {
  margin-bottom: 33px;
}
.v-t-bottom {
  font-size: 12px;
  font-weight: 300px;
  display: flex;
  justify-content: space-between;
}
.v-t-bottom .left span:nth-child(1) {
  margin-right: 6px;
}
.v-t-bottom .right {
  display: flex;
  align-items: center;
}
.v-t-bottom .right img {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}
.v-t-m-more {
  margin-top: 8px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
}
.top-search {
  width: 360px;
  height: 32px;
  position: fixed;
  padding-right: 14px;
  top: 16px;
  left: 7px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.search {
  width: 312px;
  height: 32px;
  background: #ffffff;
  opacity: 0;
  border-radius: 4px;
  margin-right: 9px;
}
.arrow-down-active {
  transform: rotate(180deg);
}
.arrow-down {
  transition: all 200ms linear;
}
.wechatShare {
  display: none;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  right: 0px;
  top: 0px;
  z-index: 10;
  font-size: 18px;
  text-align: right;
}
.wechatShare > img {
  display: inline;
  position: absolute;
  right: 18px;
  top: 4px;
  width: 60px;
  height: 60px;
}
.wechatShare p {
  color: #fff;
  font-weight: bold;
  position: absolute;
  right: 18px;
  top: 70px;
}
.wechatShare p:nth-child(2) {
  color: #fff;
  font-weight: bold;
  position: absolute;
  right: 18px;
  top: 90px;
}
/* .wechatShare /deep/ .popup {
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}
.wechatShare .article-title {
  height: 46px;
  width: 100%;
  border-bottom: 1px solid #F2F2F2;
  line-height: 46px;
  text-align: center;
  position: relative;
  font-weight: 500;
}
.wechatShare .article-title::after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  width: 20px;
  height: 20px;
  top: 12px;
  right: 9px;
  background: url('./img/close.png') no-repeat center center;
  object-fit: cover;
}

.wechatShare .article-content{
  height: 79%;
  width: 100%;
  overflow-y: auto;
  text-align: left;
  padding: 10px 15px 12px 15px;
} */
.matchTitle {
  width: 86%;
  position: absolute;
  bottom: 20px;
  left: 50%;
  bottom: 20px;
  border-radius: 16px;
  padding: 16px 12px;
  transform: translate(-50%, 0);
  background: #fff;
  text-align: center;
}
.matchTitle p:nth-of-type(1) {
  font-size: 16px;
  color: black;
  font-weight: bold;
  display: block;
}
.matchTitle .content {
    background: #f8f8f8;
    width: 100%;
    min-height: 50px;
    max-height: 92px;
    font-size: 14px;
    line-height: 24px;
    color: #383838;
    padding: 16px 12px;
    margin: 10px 0;

    /* overflow: scroll; */
    overflow-y: auto;
    -webkit-overflow-scrolling: auto;
    text-align: left;
    text-indent: 2em;
    /* border-radius: 4px; */
  }
.matchTitle p:nth-of-type(2) {
  font-size: 12px;
  color: #858585;
  display: block;
}
.fixed{
  position: fixed;
  z-index: 9999;
}
.play-circle {
  position: relative;
  z-index: 99999;
  top: 30px;
}
.v_text_index {
  z-index: 100;
}
video::-webkit-media-controls-play-button {
  display: none;
}
video::-webkit-media-controls-mute-button {
  display: none;
}
video::-webkit-media-controls-toggle-closed-captions-button {
  display: none;
}
video::-webkit-media-controls-fullscreen-button {
  display: none;
}

</style>

// WEBPACK FOOTER // // src/view/video/video.vue
